import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {ITagsFilter} from "../../../models/ITagsFilter";
import {tagsFiltersRU} from "../../../utils/data/tagsFilterDataRU";
import {ILanguage} from "../../../models/Llanguage";
import {tagsFiltersEN} from "../../../utils/data/tagsFilterDataEN";
import {tagsFiltersPL} from "../../../utils/data/tagsFilterDataPL";


const initialState: ITagsFilter[] = tagsFiltersRU

const tagsFiltersByLanguage: Record<NonNullable<ILanguage['language']>, ITagsFilter[]> = {
    ru: tagsFiltersRU,
    en: tagsFiltersEN,
    pl: tagsFiltersPL,
}

interface IAddTagsIsActive {
  idNavTag: string
  idTag: string
}


export const tagsFilterSlice = createSlice({
    name: 'tagsFilter',
    initialState,
    reducers: {

        addTagIsActive(state, action: PayloadAction<IAddTagsIsActive>) {
            state.forEach((el) => {
                if (el.idNavTag === action.payload.idNavTag) {
                    if (el.isActiveSelectors.some(tg => tg === action.payload.idTag)) {
                        el.isActiveSelectors = el.isActiveSelectors.filter(tg => tg !== action.payload.idTag)
                    } else {
                        el.isActiveSelectors.push(action.payload.idTag)
                    }

                }
            })
        },
        changeStatusActive(state, action: PayloadAction<{ idNavTag: string, statusActive: boolean }>) {
            state.forEach(el => el.statusActive = false)
            state.forEach(el => {
                if (el.idNavTag === action.payload.idNavTag) {
                    el.statusActive = action.payload.statusActive
                }
            })
        },
        changeLanguageTags(state, action: PayloadAction<ILanguage>) {
            const {language} = action.payload
            const source = (language && tagsFiltersByLanguage[language]) || tagsFiltersEN;
            return source.map((tg, i) => ({
                ...tg,
                isActiveSelectors: state[i]?.isActiveSelectors ?? tg.isActiveSelectors,
                statusActive: state[i]?.statusActive ?? tg.statusActive,
            }));
        },
        setTagsFromUrl(state, action: PayloadAction<{ problems: string[], addictions: string[] }>) {
            state[0].isActiveSelectors = action.payload.addictions;
            state[1].isActiveSelectors = action.payload.problems;
        },
    },
    extraReducers: () => {
    },
})


export const tagsFilterReducer = tagsFilterSlice.reducer
export const tagsFilterAction = tagsFilterSlice.actions
